/**
   * * @desc 订单过户信息组件
   * @description 订单类型
   * @argument 大域订单
   * @argument 自有平台订单
   * props: record  [object] //订单的信息
   * 大域成交 record.actionType === 10 && record.orderTag === 1
   *       transferMode：
       *     2  卖方
       *          produceStatus：
       *          0  待买家确认验车(status)
       *          60 提交过户信息(action)
       *     3  买方
       *          produceStatus：
       *          0  待买家确认验车(status)
       *          60 确认提车(action)
       *          70 买家上传手续中(status)
       *          80 确认过户信息(action)
       *     0  兼容老数据
   *                 确认过户(action)
   *
   * 自有平台
   *     transferMode
       *     2  卖方
       *          produceStatus：
       *          0 提交过户信息(action)
       *     3  买方
       *          produceStatus：
       *          0  确认提车(action)
       *          70 买家上传手续中(status)
       *          80 确认过户信息(action)
       *     0  兼容老数据
       *             确认过户(action)
       *
   */
import React, { Component } from 'react';
import { ProgressBar, StrategyPattern } from '@/components';
export default class TransferTypeStatus extends Component {
    constructor(props) {
        super(props);
        this.state = {
            basicBuyStatusSteps: [
                {
                    title: '确认提车',
                },
                {
                    title: '买家上传手续中',
                },
                {
                    title: '确认过户信息',
                },
            ],
            daYuStatus: [
                {
                    title: '待买家确认验车',
                },
            ],
            basicSellerStatusSteps: [
                {
                    title: '确认交车',
                },
            ],
        };
    }
    stepShow(temp, currentShow) {
        return (<ProgressBar currentShow={currentShow} progressData={temp} propsClassName="progress_style"/>);
    }
    // 根据来源不同，展示不同状态的字段
    showDiffStatus(record) {
        const context = new StrategyPattern();
        const { basicBuyStatusSteps, daYuStatus, basicSellerStatusSteps } = this.state;
        let currentShow = null;
        if (record.actionType === 10 && record.orderTag === 1) { // 大域成交
            switch (record.transferMode) {
                case 2:
                    currentShow = context.transferModeFun(2, record.produceStatus);
                    return (this.stepShow([...daYuStatus, ...basicSellerStatusSteps], currentShow));
                case 3:
                    currentShow = context.transferModeFun(2, record.produceStatus);
                    return (this.stepShow([...daYuStatus, ...basicBuyStatusSteps], currentShow));
            }
        }
        switch (record.transferMode) {
            case 3:
                currentShow = context.personalFun(record.produceStatus);
                return this.stepShow(basicBuyStatusSteps, currentShow);
        }
    }
    transferType(record) {
        switch (record.transferMode) {
            case 2:
                return '卖家过户';
            case 3:
                return '买家过户';
            default:
                return '卖家过户';
        }
    }
    render() {
        const { record } = this.props;
        return (<React.Fragment>
          <div style={{ marginBottom: '5px' }}>{this.transferType(record)}</div>
          <span>{this.showDiffStatus(record)}</span>
        </React.Fragment>);
    }
}
